import React, { useState } from 'react'
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import Cargando from './Cargando';
import Mensaje from './Mensaje';

const NotificacionesEnAndroid = () => {
    
    const {SetMensaje, BorrarTodosLosMensajes} = Mensaje();
    const {StartCargando, StopCargando} = Cargando();

    const requestPushPermission = async () => {

        if (PushNotifications && typeof PushNotifications.requestPermissions === 'function') {
          const perm = await PushNotifications.requestPermissions();
          if (perm.receive === 'granted') {
            // console.log('Permiso concedido para notificaciones');
            // Registrar el dispositivo para recibir notificaciones
            await PushNotifications.register();
          } else {
            StopCargando();
            BorrarTodosLosMensajes();
            SetMensaje("Error", "Error al activar notificacion", 3000);
            console.log('Permiso denegado para notificaciones');
          }
        } else {
          StopCargando();
          BorrarTodosLosMensajes();
          SetMensaje("Error", "Error al activar notificacion", 3000);
          console.warn('PushNotifications.requestPermissions no está disponible.');
        }
        
        
    };
      
     
    const unregister = async () => {
        await PushNotifications.unregister();
    };
    return ({
        requestPushPermission,
        unregister
      }
      )
}

export default NotificacionesEnAndroid